<template>
  <div class="calculate">
    <div class="img" :class="{img1:type==1}"></div>
    <div class="nav">
      <span :class="{s1:type==0}" @click="type=0" class="mar-r">{{$t('title.w12')}}</span>
      <span :class="{s2:type==1}" @click="type=1" class="mar-l">{{$t('title.w13')}}</span>
    </div>
    <div class="main">
      <div class="input">
        <p class="title">{{type==0?$t('label.w1'):$t('label.w2')}}</p>
        <Input v-model="money"></Input>
        <span>{{$t('label.w5')}}</span>
      </div>
      <div class="input">
        <p class="title">{{$t('label.w3')}}</p>
        <Input v-model="rate" @on-blur="handle"></Input>
        <span>%</span>
      </div>
      <div class="input" v-show="type==1">
        <p class="title">{{$t('label.w137')}}</p>
        <Select v-model="manageRate">
          <Option
            v-for="(v,i) in mgrarr"
            :key="i"
            :value="v.ManagementFeeRate"
          >{{$math.eval(`${v.ManagementFeeRate}*100`)}}%</Option>
        </Select>
      </div>
      <p class="desc" v-show="type==1">
        <span>{{$t('msg.m126')}}</span>
        <i class="micon">
          <div class="detail">
            <p>{{$t('other.w123')}}</p>
            <p v-for="(val, i) in mgrarr" :key="i" v-show="val.Amount>0">
              <span>{{$math.eval(`${val.ManagementFeeRate}*100`)}}%/月</span>:
              <span
                :style="{marginLeft:'5px'}"
              >{{$t('other.w122')}}{{i==mgrarr.length-1?'>':'≤'}}{{val.Amount | cn}}</span>
            </p>
          </div>
        </i>
      </p>
      <p class="p1">{{type==0?$t('label.w4'):$t('label.w80')}}</p>
      <div class="time">
        <span
          v-for="(v,i) in arr"
          :key="i"
          @click="select(v.value,i , v.day)"
          :class="{[type==0?'activeClass1':'activeClass']: i === isActive}"
        >{{v.text}}{{v.day == 7 || v.day == 15 ? $t('label.w15'): $t('label.w14')}}</span>
      </div>
      <div class="results">
        <div v-show="type==0" class="invest">
          <div>
            <p class="p1 color-b">{{managementFee | money}}{{$t('label.w5')}}</p>
            <p class="p2">{{$t('label.w227')}}</p>
            <p class="p3">{{$t('label.w228')}}{{onemanagementFee | money}}{{$t('label.w5')}}</p>
          </div>
          <div>
            <p class="p1 color-b">{{allInterest | money}}{{$t('label.w5')}}</p>
            <p class="p2">{{$t('label.w226')}}</p>
            <p class="p3">{{$t('label.w7')}}{{interest | money}}{{$t('label.w5')}}</p>
          </div>
          <div>
            <p class="p1 color-o">{{income | money}}{{$t('label.w5')}}</p>
            <p class="p2">{{$t('label.w229')}}</p>
            <p class="p3">{{$t('label.w230')}}{{oneincome | money}}{{$t('label.w5')}}</p>
          </div>
        </div>
        <div v-show="type==1" class="loan">
          <div class="loan-l">
            <p class="p1 color-o">{{allInterest | money}}{{$t('label.w5')}}</p>
            <p class="p2">{{$t('label.w6')}}</p>
            <p class="p3">{{$t('label.w7')}}{{interest | money}}{{$t('label.w5')}}</p>
          </div>
          <div class="loan-r">
            <p class="p1 color-o">{{allManagefee | money}}{{$t('label.w5')}}</p>
            <p class="p2">{{$t('label.w8')}}</p>
            <p class="p3">{{$t('label.w9')}}：{{managefee | money}}{{$t('label.w5')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type: 0,
      money: "",
      rate: "",
      isActive: "",
      time: "",
      manageRate: 0.005,
      manageRate1: 0.001,
      mgrarr: [],
      day: "",
      arr: [
        { text: "7", value: 1, day: 7 },
        { text: "15", value: 1, day: 15 },
        { text: "1", value: 1, day: 30 },
        { text: "2", value: 2, day: 30 },
        { text: "3", value: 3, day: 30 },
        { text: "4", value: 4, day: 30 },
        { text: "5", value: 5, day: 30 },
        { text: "6", value: 6, day: 30 },
        { text: "7", value: 7, day: 30 },
        { text: "8", value: 8, day: 30 },
        { text: "9", value: 9, day: 30 },
        { text: "10", value: 10, day: 30 },
        { text: "11", value: 11, day: 30 },
        { text: "12", value: 12, day: 30 },
      ],
    };
  },
  methods: {
    select(value, index, day) {
      this.isActive = index;
      this.time = value;
      this.day = day;
    },
    handle() {
      if (this.rate > 25) {
        this.rate = 25;
      }
    },
    getmgrate() {
      let res = this.$axios
        .get("/Member/RZJLoan/GetManagementFeerateConfig")
        .then((res) => {
          if (res.err) return res.throw();
          this.mgrarr = res;
        });
    },
  },
  mounted() {
    this.getmgrate();
  },
  computed: {
    //利息
    interest() {
      return ((this.money * (this.rate / 100)) / 12) * (this.day / 30);
    },
    //投资应付管理费
    managementFee() {
      return this.money * this.manageRate1 * (this.day / 30) * this.time;
    },
    //每期管理费
    onemanagementFee() {
      return this.money * this.manageRate1 * (this.day / 30);
    },
    //投资收益
    income() {
      return this.allInterest - this.managementFee;
    },
    oneincome() {
      return this.interest - this.onemanagementFee;
    },

    //总利息
    allInterest() {
      return (
        ((this.money * (this.rate / 100)) / 12) * (this.day / 30) * this.time
      );
    },
    //管理费
    managefee() {
      return this.money * this.manageRate;
    },
    //总管理费
    allManagefee() {
      return this.money * this.manageRate * this.time;
    },
  },
};
</script>

<style lang="less" scoped>
.calculate {
  width: 400px;
  color: #7b7b7c;
  .mar-r {
    margin-right: 35px;
  }
  .mar-l {
    margin-left: 35px;
  }
  .img {
    height: 207px;
    width: 400px;
    margin-bottom: 40px;
    background: url("../../assets/assetcenter/sidebar_bg1.png") no-repeat;
    background-size: cover;
  }
  .img1 {
    background: url("../../assets/assetcenter/sidebar_bg2.png") no-repeat;
    background-size: cover;
  }
  .nav {
    border-bottom: 1px solid #d7d7d9;
    line-height: 1.5;
    text-align: center;
    margin-bottom: 30px;
    span {
      display: inline-block;
      font-weight: 500;
      padding: 25px 0;
      font-size: 18px;
      color: #232325;
      position: relative;
      cursor: pointer;
    }
    .s1 {
      color: #6a98ff;
      &::before {
        position: absolute;
        left: 0;
        bottom: -1px;
        height: 4px;
        background: #6a98ff;
        width: 100%;
        display: block;
        content: "";
      }
    }
    .s2 {
      color: #ff6106;
      &::before {
        position: absolute;
        left: 0;
        bottom: -1px;
        height: 4px;
        background: #ff6106;
        width: 100%;
        display: block;
        content: "";
      }
    }
  }
  .main {
    width: 340px;
    margin: 0 auto;
    .input {
      margin-bottom: 25px;
      position: relative;
      .title {
        margin-bottom: 5px;
      }
      span {
        color: #232325;
        font-size: 14px;
        position: absolute;
        right: 8px;
        top: 32px;
      }
    }
    .desc {
      margin-top: -10px;
      margin-bottom: 15px;
      .micon {
        display: inline-block;
        position: relative;
        cursor: pointer;
        width: 14px;
        height: 14px;
        margin-left: 5px;
        background: url("../../assets/borrow/public_moremsg.png") no-repeat;
        background-size: cover;
        background-position: 0 0;
        vertical-align: top;
        .detail {
          display: none;
          width: 320px;
          position: absolute;
          left: -200px;
          top: 30px;
          background: #fff;
          p {
            margin-bottom: 15px;
            color: #9b9faf;
            font-style: normal;
          }
          p:first-child {
            margin-bottom: 20px;
            padding-right: 20px;
            text-align: right;
          }
        }
        &:hover {
          .detail {
            display: block;
          }
        }
      }
    }
    .p1 {
      margin-bottom: 10px;
    }
    .time {
      span {
        display: inline-block;
        padding: 2px 5px;
        border-radius: 2px;
        margin: 0 10px 11px 0;
        border: 1px solid rgba(155, 159, 175, 1);
        cursor: pointer;
      }
      .activeClass {
        background: #ff6106;
        border-color: #ff6106;
        color: #fff;
      }
      .activeClass1 {
        background: #6a98ff;
        border-color: #6a98ff;
        color: #fff;
      }
    }
    .results {
      margin-top: 50px;
      .color-o {
        color: #ff6106;
      }
      .color-b {
        color: #6a98ff;
      }
      .p1 {
        font-size: 18px;
        margin-bottom: 8px;
      }
      .p2 {
        margin-bottom: 20px;
      }
      .p3 {
        color: #232325;
      }
      .loan {
        display: flex;
        .loan-l {
          width: 50%;
          text-align: center;
        }
        .loan-r {
          width: 50%;
          text-align: center;
        }
      }
      .invest {
        // text-align: center;
        display: flex;
        align-content: center;
        div {
          width: 33.33%;
          text-align: center;
        }
      }
    }
  }
}
</style>
